import React from 'react';
import { useParams } from 'react-router-dom';
import TransactionStats from './TransactionStats';

const ProcessorDetail = () => {
  const { processorId } = useParams();

  return (
    <>
      <TransactionStats processorId={processorId} />
    </>
  );
};

export default ProcessorDetail;
